<template>
  <transition name="el-zoom-in-center">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content-noneheader">
        <!-- Default box -->
        <div class="box">
          <div class="box-header">
            <div class="box-header with-border">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>学校管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/teacher/teacherList' }">教师列表</el-breadcrumb-item>
                <el-breadcrumb-item>教师信息</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div class="box-body">
            <div style="width: auto; text-align: center">
              <!-- 详细样式参考 http://element-cn.eleme.io/#/zh-CN/component/form -->
              <el-form ref="form" :model="vo" label-width="150px" class="form-default">
                <el-col :span="11">
                  <el-form-item label="用户名" prop="name" :rules="[{required: true, message: '请输入', trigger: 'blur'}, {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}]">
                    <el-input v-model="vo.name"></el-input>
                  </el-form-item>
                </el-col>
<!--                <el-col :span="11">-->
<!--                  <el-form-item label="微信号">-->
<!--                    <el-input v-model="vo.weChat" :disabled="true"></el-input>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
                <el-col :span="11">
                  <el-form-item label="手机" prop="phone" :rules="[{required: true, message: '请输入', trigger: 'blur'}, { min: 11, max: 11, message: '请输入11位手机号码', trigger: 'blur' }, {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码'}]">
                    <el-input v-model="vo.phone"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="11">
                  <el-form-item label="类型" prop="type" :rules="[{required: true, message: '请选择', trigger: 'blur'}]">
                    <el-select v-model="vo.type" style="width: 100%" :disabled="vo.id && vo.id > 0">
                      <el-option label="教师" value="MP_USER"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <!-- 学校级别的信息 -->
                <el-col :span="11">
                  <el-form-item label="学校" prop="departmentId" v-if="!departmentId"
                                :rules="[{required: true, message: '请选择', trigger: 'blur'}]">
                    <el-select v-model="vo.departmentId" style="width: 100%" autocomplete filterable>
                      <el-option v-for="d in departmentList" :label="d.name" :value="d.id" :key="d.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="11">
                  <el-form-item label="员工号" prop="schoolNo"
                                :rules="[{required: true, message: '请输入', trigger: 'blur'}, {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}]">
                    <el-input v-model="vo.schoolNo"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="11">
                  <el-form-item label="学校部门" prop="schoolDeptName"
                                :rules="[{min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}]">
                    <el-input v-model="vo.schoolDeptName"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="11">
                  <el-form-item label="人员性质" prop="nature"
                                :rules="[{min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}]">
                    <el-input v-model="vo.nature"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="11">
                  <el-form-item label="银行账号" prop="account"
                                :rules="[{min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur'}]">
                    <el-input v-model="vo.account"></el-input>
                  </el-form-item>
                </el-col>

                <!--<el-col :span="11">-->
                  <!--<el-form-item label="年龄">-->
                    <!--<el-input v-model="vo.age" :disabled="true"></el-input>-->
                  <!--</el-form-item>-->
                <!--</el-col>-->
<!--                <el-col :span="11">-->
<!--                  <el-form-item label="性别">-->
<!--                    <el-input v-model="vo.sex" :disabled="true"></el-input>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
<!--                <el-col :span="11">-->
<!--                  <el-form-item label="生日">-->
<!--                    <el-input v-model="vo.birthday" :disabled="true"></el-input>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
                <!--<el-col :span="5">-->
                  <!--<el-form-item label="群组管理">-->
                      <!--<el-button  icon="el-icon-search" @click="handlePopRefUserBtnClick"  :disabled="changeUser"></el-button>-->
                  <!--</el-form-item>-->
                <!--</el-col>-->
                <el-col :span="20">
                  <el-form-item>
                    <el-button type="primary" :disabled="!canSubmit" @click="onSubmit('form')">确定</el-button>
                    <el-button @click="onCancel">返回</el-button>
                  </el-form-item>
                </el-col>
              </el-form>
            </div>
          </div>

          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'UserModify',
    data: function () {
      return {
        createOpt: true, // 是否新建操作
        departmentList: [], // 学校列表
        departmentId: null, // 学校id （如果为 null 表示管理员操作）
        canSubmit: true,
        vo: {
          name: null, phone: null, departmentId: null, type: 'MP_USER'
        }
      }
    },
    mounted: function () {
      // 编辑的时候会有有id参数
      let id = this.$route.query.id;
      this.departmentId = this.$route.query.departmentId;
      // console.log(this.departmentId);
      if (this.departmentId) { // 学校id （如果为 null 表示管理员操作）
        this.vo.departmentId = this.departmentId;
      } else { // 学校id （如果为 null 表示管理员操作）
        this.axios.get('/admin/department/findAll4Select')
          .then(resp => { // 装载对象
            if (resp.data && resp.data.code === 200) {
              this.departmentList = resp.data.data
            } else {
              this.$router.replace('/user/userList')
              this.$message({
                type: 'error',
                message: "获取部门列表失败"
              })
            }
          }).catch(resp => {
          this.$router.replace('/user/userList')
          this.$message({
            type: 'error',
            message: "请求服务器出错"
          })
        })
      }
      if (id) {
        this.createOpt = false
        this.axios.get('/admin/user/find', {params: {id: id}})
          .then(resp => { // 装载对象
            if (resp.data && resp.data.code === 200) {
              this.vo = resp.data.data
            } else {
              this.$router.replace('/user/userList')
              this.$message({
                type: 'error',
                message: "查询失败-该用户非App注册用户"
              })
            }
          }).catch(resp => {
          this.$router.replace('/user/userList')
          this.$message({
            type: 'error',
            message: "请求服务器出错"
          })
        })
      }
    },
    methods: {
      onSubmit: function (formName) {
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.canSubmit = false;
            this.axios.post('admin/user/save', that.vo)
              .then(resp => { // 保存成功跳回列表页面
                if (resp.data && resp.data.code === 200) {
                  this.$message({
                    type: 'success',
                    message: '处理成功!'
                  });
                  this.$router.replace('/teacher/teacherList');
                } else {
                  this.$message({
                    type: 'error',
                    message: '处理失败!' + resp.data.message
                  })
                  this.canSubmit = true;
                }
              }).catch(resp => {
              this.$message({
                type: 'error',
                message: "请求服务器出错"
              });
              this.canSubmit = true;
            })
          } else {
            return false;
          }
        });
      },
      onCancel: function () {
        this.$router.replace('/teacher/teacherList')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TeacherModify.vue?235044a7